module.exports = __webpack_public_path__ + "img/lc-detail.72079b9a.svg";